import { types, type Instance } from 'mobx-state-tree';
export const MatchedQuality = types.model('MatchedQuality', {
  id: types.string,
  displayLabel: types.string,
  isTop: types.boolean,
  relevanceScore: types.number,
});
export type IMatchedQuality = Instance<typeof MatchedQuality>;

export const MatchedQualities = types.model('MatchedQualities', {
  qualities: types.maybeNull(types.array(MatchedQuality)),
  /**
   * FIXME: `hasError` is always false. We no longer use this field and this should be removed.
   * @deprecated
   */
  hasError: types.optional(types.boolean, false),
});
